import {
  INSERT_LOW_BATT_REPORT,
  INSERT_DORMANT_DEVICES_REPORT,
  INSERT_MISSING_DEVICES_REPORT,
  INSERT_ACTIVE_TAMPER_REPORT,
  INSERT_AUDIT_LOGS_REPORT,
  APPEND_AUDIT_LOGS_REPORT,
  APPEND_ACTIVE_TAMPER_REPORT,
  APPEND_MISSING_DEVICES_REPORT,
 APPEND_LOWBATT_REPORT,
 APPEND_DORMANT_DEVICES_REPORT,
} from '../actions/reportsActions';

function reports(
  state = {
    devices: {
      echoStream: [],
      lowBatt: [],
      dormant: [],
      missing: [],
      activeTamper: [],
    },
    logs: {
      auditLogs: [],
    },
  },
  action
) {
  switch (action.type) {
    case INSERT_LOW_BATT_REPORT:
      return {
        ...state,
        devices: {
          ...state.devices,
          lowBatt: action.payload,
        },
      };
      case APPEND_LOWBATT_REPORT:
        const templowBatt = state.devices.lowBatt.concat(...action.payload); 
        return {
          ...state,
          devices: {
            ...state.devices,
            lowBatt:templowBatt
            } 
        };
    case INSERT_DORMANT_DEVICES_REPORT:
      return {
        ...state,
        devices: {
          ...state.devices,
          dormant: action.payload,
        },
      };
      case APPEND_DORMANT_DEVICES_REPORT:
        const tempdormant = state.devices.dormant.concat(...action.payload); 
        return {
          ...state,
          devices: {
            ...state.devices,
            dormant:tempdormant
            } 
        };
    case INSERT_MISSING_DEVICES_REPORT:
      return {
        ...state,
        devices: {
          ...state.devices,
          missing: action.payload,
        },
      };
      case APPEND_MISSING_DEVICES_REPORT:
        const tempMissingDevices = state.devices.missing.concat(...action.payload); 
        return {
          ...state,
          devices: {
            ...state.devices,
            missing:tempMissingDevices
            }
            
        };
    case INSERT_ACTIVE_TAMPER_REPORT:
      return {
        ...state,
        devices: {
          ...state.devices,
          activeTamper: action.payload,
        },
      };
      case APPEND_ACTIVE_TAMPER_REPORT:
        const tempActiveTamper = state.devices.activeTamper.concat(...action.payload); 
        return {
          ...state,
          devices: {
            ...state.devices,
            activeTamper:tempActiveTamper 
            }
            
        };
    case INSERT_AUDIT_LOGS_REPORT:
        return {
          ...state,
          logs: {
           auditLogs:[...action.payload]
          }
        };
    case APPEND_AUDIT_LOGS_REPORT:
      const tempAuditLogs = state.logs.auditLogs.concat(...action.payload);  
      return {
        ...state,
        logs: {
          auditLogs:tempAuditLogs
        }
      };
    default:
      return state;
  }
}
export default reports;
